var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Response',{attrs:{"view":"error","title":"Оплата отклонена","description":"Дополнительные детали о платеже доступны в приложении банка"}})
}
var staticRenderFns = []

export { render, staticRenderFns }